<template>
  <v-container fluid>
    <v-row class="mt-4">
      <v-col cols="6">
        <v-btn block color="error" @click="voltar">
          <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
        >
      </v-col>
      <v-col cols="6">
        <e-censo-dialog-texto />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {
    this.getData();
  },

  methods: {
    voltar() {
      this.$emit("event", "tab-7");
    },
    deixarMaisculo() {
      this.formData.logradouro.toUpperCase();
    },
    validarData(data) {
      if (!data) return "Campo obrigatório";
      const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!regex.test(data)) return "Data inválida (formato esperado: dd/mm/yyyy)";
      const [dia, mes, ano] = data.split("/");
      const date = new Date(ano, mes - 1, dia);
      if (date.getDate() !== dia || date.getMonth() + 1 !== mes || date.getFullYear() !== ano) {
        return "Data inválida";
      }
      return true;
    },

    async getData() {
      this.$loaderService.open("Carregando...");
      const data = await this.$services.censoService.getData("aba00");
      this.formData = data;
      if (data.censo) {
        this.formData = data.censo;
      }
      this.$loaderService.close();
    },
  },
};
</script>
